import { Menu } from "@headlessui/react";
import { cx } from "cva";
import { MenuTransition } from "~/components/Menu";
import {
  SocialMediaShareButton,
  SocialMediaShareButtonProps,
} from "~/components/SocialMediaShareButton/SocialMediaShareButton";
import {
  getFacebookUrl,
  getLinkedInUrl,
  getShareEmailUrl,
  getTwitterUrl,
} from "~/lib/client/getSocialMediaUrl";
import { Icon } from "~/ui-library";
import {
  EmailIcon,
  FacebookIcon,
  LinkedInIcon,
  TwitterIcon,
} from "~/ui-library/icons";
import { menuItemsStyles } from "~/ui-library/shared-styles/shared-menu-styles";

type RenderProps = SocialMediaShareButtonProps;

export type SocialMediaShareMenuItemsProps = {
  isOpen: boolean;
  shareTitle: string;
  shareUrl: string;
};

export const SocialMediaShareMenuItems: React.FC<
  SocialMediaShareMenuItemsProps
> = ({ isOpen, shareTitle, shareUrl }) => {
  const items: RenderProps[] = [
    {
      href: getFacebookUrl({
        shareTitle,
        shareUrl,
      }),
      label: "Facebook",
      icon: <Icon size="small" SvgIcon={FacebookIcon} />,
    },
    {
      href: getTwitterUrl({
        shareTitle,
        shareUrl,
      }),
      label: "Twitter",
      icon: <Icon size="small" SvgIcon={TwitterIcon} />,
    },
    {
      href: getLinkedInUrl({
        shareTitle,
        shareUrl,
      }),
      label: "LinkedIn",
      icon: <Icon size="small" SvgIcon={LinkedInIcon} />,
    },
    {
      href: getShareEmailUrl({
        shareTitle,
        shareUrl,
      }),
      label: "Email",
      icon: <Icon size="small" SvgIcon={EmailIcon} />,
    },
  ];

  return (
    <MenuTransition isOpen={isOpen}>
      <Menu.Items
        className={cx("z-20 w-fit flex-col gap-xs p-s", menuItemsStyles)}
      >
        {items.map((item, idx) => (
          <Menu.Item key={idx}>
            <SocialMediaShareButton.Small {...item} />
          </Menu.Item>
        ))}
      </Menu.Items>
    </MenuTransition>
  );
};
